import { render } from "./formulario_recepcion.vue?vue&type=template&id=e83db704"
import script from "./formulario_recepcion.vue?vue&type=script&lang=js"
export * from "./formulario_recepcion.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__